"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

// Use span if no Fragment support
var Fragment = _react.default.Fragment || 'span';
var _default = Fragment;
exports.default = _default;
module.exports = exports.default;